import { render, staticRenderFns } from "./ModalScharffRealPlaza.vue?vue&type=template&id=574b916f&scoped=true&"
import script from "./ModalScharffRealPlaza.vue?vue&type=script&lang=js&"
export * from "./ModalScharffRealPlaza.vue?vue&type=script&lang=js&"
import style0 from "./ModalScharffRealPlaza.vue?vue&type=style&index=0&id=574b916f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574b916f",
  null
  
)

export default component.exports